import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, IconButton, Tooltip } from '@mui/material';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import { useBookingNotes } from '@/hooks/useBookingNotes';
import { WorkOrderNotesDialog } from './WorkOrderNotesDialog';

interface WorkOrderNotesButtonProps {
  bookingId: string;
}

export function WorkOrderNotesButton({ bookingId }: WorkOrderNotesButtonProps) {
  const { t } = useTranslation('workorders');
  const [open, setOpen] = useState(false);

  const { data: notes = [] } = useBookingNotes(bookingId);
  const noteCount = notes.length;
  const tooltip =
    noteCount > 0
      ? t('notesHistory.notesCount', { count: noteCount })
      : t('notesHistory.notesTitle');

  return (
    <>
      <Tooltip title={tooltip}>
        <IconButton
          size="small"
          aria-label={tooltip}
          onClick={(e) => {
            e.stopPropagation();
            setOpen(true);
          }}
        >
          <Badge
            color="primary"
            variant="dot"
            invisible={noteCount === 0}
            overlap="circular"
          >
            <StickyNote2Icon fontSize="small" />
          </Badge>
        </IconButton>
      </Tooltip>
      {open && (
        <WorkOrderNotesDialog
          open={open}
          onClose={() => setOpen(false)}
          bookingId={bookingId}
        />
      )}
    </>
  );
}
